var amt_admin = require("amt_admin").default;
var app = require("angular").module("ww2_analytics.alliance_war", [amt_admin]);

app.config(["$stateProvider", function($stateProvider) {
  $stateProvider
    .state('amt.ww2.alliance_war', {
      url: "/alliance_war",
      abstract: true,
      template: '<div class="row" ui-view></div>',
      data: {
        priority: 801,
        title: "Alliance War",
        role: "alliance_war"
      },
      menu: {
        glyphicon: 'text-background',
        childs: [
          {state: 'amt.ww2.alliance_war.activity', glyphicon: 'text-background'},
        ],
      },
    })
    .state('amt.ww2.alliance_war.activity', require('./activity').default)
}]);

export default app.name;
